import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { useTranslation } from 'core/i18n/i18n';
import { useMaterialDefinitionForm } from './hooks/use-material-definition-form.hook';
import { SettingsMaterialDefinitionsFormComponent } from './settings-material-definitions-form.component';
import {
    MaterialDefinitionFormContentWrapper,
    MaterialDefinitionWorkflowOverlay,
} from './settings-material-definitions-form.style';

export const SettingsMaterialDefinitionsFormContainer: React.FC = () => {
    const { t } = useTranslation();
    const {
        formState,
        errors,
        testConfigsError,
        targetErrors,
        deviceTypes,
        tests,
        isLoading,
        readOnlyLotRules,
        handleAddTest,
        handleRemoveTest,
        handleTestChange,
        handleDataChange,
        handleResultTypeChange,
        handlePossibleValuesChange,
        handleRangeModeChange,
        handleAddLevel,
        handleRemoveLevel,
        handleLevelChange,
        handleValidity,
        handleSave,
        handleCancel,
        isDataValid,
        isSaving,
        headerTitleKey,
    } = useMaterialDefinitionForm();

    return (
        <MaterialDefinitionWorkflowOverlay
            visible
            loading={isLoading}
            headerTitle={t(headerTitleKey)}
            onClose={handleCancel}
            className="show-header"
            footer={[
                <PocButton
                    key="cancel-button"
                    variant="secondary"
                    onMouseDown={(event) => event.preventDefault()}
                    onClick={handleCancel}
                >
                    {t('commons.components.modal.modal-dialog.footer.button.cancel')}
                </PocButton>,
                <PocButton key="save-button" onClick={handleSave} disabled={!isDataValid() || isSaving}>
                    {t('commons.components.modal.modal-dialog.footer.button.save')}
                </PocButton>,
            ]}
        >
            <MaterialDefinitionFormContentWrapper>
                <SettingsMaterialDefinitionsFormComponent
                    formState={formState}
                    onFieldChange={handleDataChange}
                    onValidity={handleValidity}
                    errors={errors}
                    testConfigsError={testConfigsError}
                    targetErrors={targetErrors}
                    deviceTypes={deviceTypes}
                    tests={tests}
                    onAddTest={handleAddTest}
                    onRemoveTest={handleRemoveTest}
                    onTestChange={handleTestChange}
                    onResultTypeChange={handleResultTypeChange}
                    onPossibleValuesChange={handlePossibleValuesChange}
                    onRangeModeChange={handleRangeModeChange}
                    onAddLevel={handleAddLevel}
                    onRemoveLevel={handleRemoveLevel}
                    onLevelChange={handleLevelChange}
                    readOnlyLotRules={readOnlyLotRules}
                />
            </MaterialDefinitionFormContentWrapper>
        </MaterialDefinitionWorkflowOverlay>
    );
};
